import { useState, useEffect } from 'react';
import { IconButton, useTheme } from '@mui/material';
import { BriefcaseBusinessIcon } from 'lucide-react';
import { useUser } from '@/components/AuthInterceptorComponent/hooks/useUser';

export const RedirectToDashboard = () => {
  const theme = useTheme();
  const [staff, setStaff]: any = useState(null);
  const { user } = useUser();

  const showButton = staff && staff.url_redirection && staff.is_staff;

  const handleRedirect = () => {
    if (staff.url_redirection) window.location.href = staff.url_redirection;
  };
  useEffect(() => {
    setStaff(user?.super_staff_data);
  }, []);

  return (
    <>
      {showButton && (
        <IconButton onClick={handleRedirect}>
          <BriefcaseBusinessIcon size={22} color={theme.palette.primary.main} />
        </IconButton>
      )}
    </>
  );
};
